import getUserIP, { formatIPJSON } from "../../../utils/getUserIP";

export const getUserFeedbackCompletedFlag = async () => {
  return await localStorage.getItem("has_completed_user_feedback")
}
export const retrieveUserIP = async () => {
  try {
    const userIP = await getUserIP();
    return formatIPJSON(userIP);
  } catch {
    return "IP tracing blocked by ad-blocker or CORS"
  }
}